import React from 'react';
import OperationalParametersHeaderComponent from './OperationalParametersHeaderComponent';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { getModel } from './selectors';
import * as actions from './actions';


const OperationalParametersHeaderContainer = (props) => {
    return <OperationalParametersHeaderComponent {...props} />;
};

const mapStateToProps = (state) => {
    const model = getModel(state);
    return {
        model
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(actions, dispatch)
    };
};

const OperationalParametersHeaderContainerConn = connect(
    mapStateToProps,
    mapDispatchToProps
)(OperationalParametersHeaderContainer);

export default OperationalParametersHeaderContainerConn;
